import { render, staticRenderFns } from "./AvisoDePrivacidadv2.vue?vue&type=template&id=235e01b8&scoped=true&"
import script from "./AvisoDePrivacidadv2.vue?vue&type=script&lang=js&"
export * from "./AvisoDePrivacidadv2.vue?vue&type=script&lang=js&"
import style0 from "./AvisoDePrivacidadv2.vue?vue&type=style&index=0&id=235e01b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235e01b8",
  null
  
)

export default component.exports